import { FiAlertOctagon } from "react-icons/fi";

const Renewal = ({isConnectToStore, number, onClick}) => {
  return (
    <div className="flex flex-col items-center py-36 gap-7">
      <span className="flex w-full justify-center">
        <FiAlertOctagon className="w-20 h-20 text-yellow-c-everyday" />
      </span>
      <p className="text-3xl font-semibold text-center">
        서비스 준비중입니다.
      </p>
      <div className="text-sm font-medium text-center text-gray-700">
        보다 나은 서비스 제공을 위하여 페이지 준비중에 있습니다. <br/> 
        빠른 시일 내에 준비하여 찾아뵙겠습니다.
      </div>
      {
        isConnectToStore && (
          <a href={`tel:${number}`} onClick={onClick} className="flex w-4/5 justify-between items-center bg-yellow-c-everyday rounded-[20px] py-5 mx-5 px-3">
            <div className="flex w-full items-center gap-2.5 text-xl font-semibold break-normal justify-center">
              점포 연결
            </div>
          </a>
        )
      }
    </div>
  );
};

export default Renewal;
